import {
  BusStoreIconFontSVG,
  BusStoreIconFontTTF,
  BusStoreIconFontWOFF
} from '../fonts';

export const iconFont = `
    @font-face {
      font-family: 'busstore-icons';
      src: url('${BusStoreIconFontWOFF}') format('woff'),
        url('${BusStoreIconFontTTF}') format('truetype'),
        url('${BusStoreIconFontSVG}') format('svg');
      font-weight: normal;
      font-style: normal;
      font-display: block;
    }
`;
